import React, {Component, Fragment} from 'react';
import {connect} from "react-redux";
import PropTypes from 'prop-types';
import windowSize from "../libs/reactWindowSize";
import { withScenePosition } from "../scenePosition";
import {Modal} from "react-router-modal";
import SVG from "react-svg";
import Checkbox from 'rc-checkbox';
import { Translate } from 'react-localize-redux';

import closeImg from "../images/x.svg";

class OrientationModal extends Component {

  constructor(props){
    super(props);
    this.state = {};

    this.nextOrientation = this.nextOrientation.bind(this);
    this.previousOrientation = this.previousOrientation.bind(this);
    this.openOrientation = this.openOrientation.bind(this);
    this.closeOrientation = this.closeOrientation.bind(this);
    this.optOutOrientation = this.optOutOrientation.bind(this);
  }

  static getDerivedStateFromProps(props, state){
    return {
      ...state
    }
  }

  nextOrientation() {
    let { dispatch } = this.props;
    dispatch({
      type: "orientation/NEXT"
    });
  }

  previousOrientation() {
    let { dispatch } = this.props;
    dispatch({
      type: "orientation/BACK"
    });
  }

  openOrientation() {
    let { dispatch } = this.props;
    dispatch({
      type: "orientation/OPENED"
    });
  }

  closeOrientation() {
    let { dispatch } = this.props;
    dispatch({
      type: "orientation/CLOSED"
    });
  }

  optOutOrientation(e) {
    const optOutValue = e.target.checked;
    localStorage.setItem('orientationOptOut', optOutValue);
  }

  render() {
    const { left, top, width, height, orientationState } = this.props;

    return (
      <Fragment>

      {orientationState.isOpen ?
        <Modal className="orientation-modal react-router-modal__modal">
          <div className="orientation-wrapper" style={{top: top, left: left, width: width, height: height}} >
            <h1><Translate id={orientationState.data.title}/></h1>
            <div className="progress-wrapper">
              {orientationState.data.steps.map(function(step, index){ if (index > 0 ) { return (
                <Fragment>
                  { index > 1 &&
                  <div className="progress-waypoint"></div>
                  }
                  <div className={"progress-point " + (index === orientationState.step ? "active" : "")}></div>
                </Fragment>
              )} else {
                return null
              } })}
            </div>
            <div className="orientation-content">
              <div className="orientation-image"><img alt="orientation" src={`${window.public_url}${orientationState.data.steps[orientationState.step].image}`} /></div>
              <div className={`orientation-copy ${orientationState.step === 0 ? 'intro': ''}`}>
                <div className="copy">
                  <h2>{orientationState.data.steps[orientationState.step].subTitle ? <Translate id={orientationState.data.steps[orientationState.step].subTitle} /> : undefined}</h2>
                  <p><Translate id={orientationState.data.steps[orientationState.step].paragraph}/></p>
                </div>
                <div>
                  {orientationState.step < orientationState.data.steps.length-1 &&
                    <button className="fill-next-button" onClick={this.nextOrientation}><Translate id="orientationNext"/></button>
                  }
                  {orientationState.step === orientationState.data.steps.length-1 &&
                    <Fragment>
                    <div className="orientation-checkbox-wrapper">
                      <Checkbox
                          className="orientation-checkbox"
                          name="doNotShow"
                          onChange={this.optOutOrientation} />
                      <span><Translate id="orientationDoNotShowAgain"/></span>
                    </div>
                    <button className="fill-next-button" onClick={this.closeOrientation}><Translate id="orientationStartYourTour"/></button>
                    </Fragment>
                  }
                  {orientationState.step > 0 &&
                    <button className="back-button" onClick={this.previousOrientation}><Translate id="orientationBack"/></button>
                  }
                </div>
              </div>
            </div>

          </div>
          <button className="close-button" onClick={this.closeOrientation} ><SVG src={closeImg} /></button>
        </Modal>
      : null }

      </Fragment>
    );
  }

}

OrientationModal.propTypes = {

};

OrientationModal.defaultProps = {

}

function mapStateToProps(state) {
  return {
    scene: state.scene,
    step: state.step,
    orientationState: state.orientation
  }
}

export default windowSize(connect(mapStateToProps)(withScenePosition(OrientationModal)));



// WEBPACK FOOTER //
// ./src/components/OrientationModal.jsx